import { ColumnFilter } from '@tanstack/table-core';
import { MRT_ColumnFiltersState } from 'material-react-table';

/**
 * Generates a string of sort parameters based on an array of objects with 'id' and 'desc' properties in out backend sort format.
 *
 * @param {Array<{id: string, desc: boolean}>} sort - An array of objects representing the sort parameters.
 * @return {string} - A string of sort parameters in the format 'sort=prefix.id,desc|asc&sort=prefix.id,desc|asc...'
 */
export const makeSortParameters = (sort: { id: string; desc: boolean }[]) =>
  sort.map(item => `sort=${item.id},${item.desc ? 'desc' : 'asc'}`).join('&');

/**
 * Generates column filter parameters based on the provided column filters and optional multiSelectFields.
 *
 * @param {MRT_ColumnFiltersState} columnFilters - The column filters to generate parameters from (auto-generated from mrt table).
 * @param {string[]} multiSelectFields - Optional multi-select fields to consider.(multi-select filter fields in mrt table)
 * @return {string} - A string of column filter parameters.
 */
export const makeColumnFiltersParameters = (
  columnFilters: MRT_ColumnFiltersState,
  multiSelectFields?: string[]
) =>
  columnFilters
    ?.map(filter =>
      //for firstname we have our column id saved as firstname since we show in in just one column, we can or first and lastname here to show both
      filter.id.includes('firstname')
        ? `operator=OR&${filter.id}__icontains=${encodeURIComponent(
            filter.value as string
          )}&user.lastname__icontains=${encodeURIComponent(
            filter.value as string
          )}`
        : multiSelectFields?.includes(filter.id)
        ? getMultiSelectParams(filter)
        : `${filter.id}__icontains=${encodeURIComponent(
            filter.value as string
          )}`
    )
    .join('&');

const getMultiSelectParams = (filter: ColumnFilter) => {
  const notNullFilterValues = (filter.value as string[]).filter(
    item => item !== 'null'
  );

  return `${
    notNullFilterValues.length > 0
      ? `&${filter.id}=${notNullFilterValues.join(',')}`
      : ''
  }${
    (filter.value as string[]).includes('null')
      ? `&${filter.id}__isnull=true`
      : ''
  }`;
};
